import React from 'react';
import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress';

class Spinner extends React.Component {
 
    render() {

        return (
            <div className="centered" >
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <CircularProgress color={this.props.color || (window.muiTheme && window.muiTheme.palette.primary1Color) || "#ffffff"} /> 
            </div>
        )
    }
}


function mapStateToProps(state) {
  
    const {  isFetching } = state.thisApp.environment
    
    return {
       isFetching
    }
}

export default connect(mapStateToProps)(Spinner);


// WEBPACK FOOTER //
// ./src/Components/Spinner.js